import Clock from './Clock.js';
export { Clock };
export default Clock;
